import { FC } from 'react';
import {
  Button,
  ButtonIconPosition,
  ButtonStyles,
  ButtonWidth,
  IconAnimationClassName,
  Theme,
} from '@nextgen-web-framework/all';
import { SubscribeCtaWithIconProps } from './types/propTypes';

const SubscribeCtaWithIcon: FC<SubscribeCtaWithIconProps> = ({ isLoading, title, ...restProps }) => (
  <Button
    title={!isLoading ? title : undefined}
    aria-label="Stepper Button"
    buttonStyle={ButtonStyles.SOLID}
    theme={Theme.BLACK}
    buttonWidth={ButtonWidth.FULL_WIDTH}
    iconPosition={ButtonIconPosition.LEFT}
    {...(isLoading
      ? {
          icon: {
            iconName: 'spinner-third',
            iconAnimationClassName: IconAnimationClassName.SPIN,
          },
        }
      : {
          icon: { iconName: 'refresh' },
        })}
    {...restProps}
  />
);

export default SubscribeCtaWithIcon;
